module.exports = __webpack_public_path__ + "static/media/712+GkpF-wL._SL1500_.03392638.jpg";